export default __webpack_public_path__ + "static/media/support-notes-logo-en-concreto.103ac894.svg";